import { gql } from "lib/apolloClient";

export const configurationV2ItemFragment = {
  configurationV2Item: gql`
    fragment configurationV2Item on ConfigurationV2 {
      id
      uidV2
      configuration
      valueType
      value
      isLocked
      __typename
    }
  `,
};

export const configurationV2SettingItemFragment = {
  configurationV2SettingItem: gql`
    fragment configurationV2SettingItem on ConfigurationV2 {
      id
      uidV2
      configuration
      valueType
      value
      isLocked
      state
      enabledEntityGroups(filters: { entityTypeGroups: [COURSE] }) {
        entities {
          entityId
          entityType
          resolvedEntity {
            ... on Course {
              id
              title
              curriculumProgram {
                id
                type
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      validPlatforms
      platformCategorizedValues {
        default
        staff
        parent
        student
        __typename
      }
      configurationGroup
      parentConfigurations {
        id
        __typename
      }
      __typename
    }
  `,
};

export const configurationResponseItemFragment = {
  configurationResponseItem: gql`
    fragment configurationResponseItem on ConfigurationResponse {
      configurations @include(if: $isSettingsPage) {
        ...configurationV2SettingItem
        __typename
      }
      configurations @skip(if: $isSettingsPage) {
        ...configurationV2Item
        __typename
      }
      entityGroups @include(if: $isAdminPage) {
        entityId
        entityType
        __typename
      }
      __typename
    }
    ${configurationV2SettingItemFragment.configurationV2SettingItem}
    ${configurationV2ItemFragment.configurationV2Item}
  `,
  preferenceResponseItem: gql`
    fragment configurationResponseItem on ConfigurationResponse {
      configurations {
        ...configurationV2Item
        __typename
      }
      entityGroups @include(if: $isAdminPage) {
        entityId
        entityType
        __typename
      }
      __typename
    }
    ${configurationV2ItemFragment.configurationV2Item}
  `,
};
